import { useState } from "react";
import { router } from "@inertiajs/react";
import { TermsOfServiceForm } from "@components/terms_of_service/form";
import { Body, SectionHeader } from "@sprout/typography";
import useTranslation from "@hooks/use_translation";
import { PrimaryButton } from "@sprout/buttons";

const UpdatedUserAgreement = () => {
  const { t } = useTranslation("misc");

  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async () => {
    setIsSubmitting(true);
    setError(null);

    const defaultErrorMessage = t("defaultError");

    try {
      router.post(window.location.href, {
        accept_terms: acceptedTerms ? "1" : "0",
      });
    } catch (e) {
      console.error(e);
      setError(defaultErrorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="container">
      <SectionHeader>{t("updatedUserAgreement.header")}</SectionHeader>
      <main>
        <Body>{t("updatedUserAgreement.notice")}</Body>
        <TermsOfServiceForm error={error} onChange={setAcceptedTerms} value={acceptedTerms} />
        <div>
          <PrimaryButton onClick={handleSubmit} loading={isSubmitting} disabled={!acceptedTerms}>
            {t("submit")}
          </PrimaryButton>
        </div>
      </main>
    </div>
  );
};

export default UpdatedUserAgreement;
